import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import DashboardStatusCards from '../../components/ui/DashboardStatusCards';
import GlobalSearch from '../../components/ui/GlobalSearch';
import QuickActions from './components/QuickActions';
import SystemStats from './components/SystemStats';
import Footer from 'components/ui/Footer';

const Dashboard = () => {
  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update current time every minute
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  // Check authentication
  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      navigate('/login-screen');
    }
  }, [navigate]);

  const formatDateTime = (date) => {
    return date.toLocaleString('en-IN', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <Breadcrumb />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-8">
          {/* Welcome Section */}
          <div className="mb-8">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h1 className="text-3xl font-heading font-semibold text-foreground mb-2">
                  Welcome to Tamil Nadu Prasanthi Seva
                </h1>
                <p className="text-muted-foreground">
                  Registration Management Dashboard
                </p>
              </div>
              <div className="mt-4 sm:mt-0 text-right">
                <p className="text-sm text-muted-foreground">
                  {formatDateTime(currentTime)}
                </p>
                <div className="flex items-center justify-end space-x-2 mt-1">
                  <div className="w-2 h-2 bg-success rounded-full animate-spiritual-pulse"></div>
                  <span className="text-xs text-success font-caption">System Online</span>
                </div>
              </div>
            </div>
          </div>

          {/* Global Search */}
          <GlobalSearch />

          {/* Status Cards */}
          <DashboardStatusCards />

          {/* Main Dashboard Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
            {/* Left Column */}
            <div className="space-y-8">
              <QuickActions />
            </div>

            {/* Right Column */}
            <div className="space-y-8">
            <SystemStats />
              {/* Removed <RecentActivity /> and <UpcomingEvents /> */}
            </div>
          </div>

        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default Dashboard;